import { Plugin } from "chart.js";

export const useYAxisPlugin = (): Plugin => {
	const chartPlugin: Plugin<"line"> = {
		id: "yAxisPlugin",
	};

	return chartPlugin;
};
